import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';
import { notificationsKeys } from '@data/constants';
import { NotificationListView, NotificationsApiGetNotificationsRequest } from '@data/sdk/match';
import { MatchingApi } from '@data/utils/axios-instance';

export const useNotificationsList = () => {
  const params = {
    limit: 15,
  };

  const { data, fetchNextPage, hasNextPage, isLoading, isFetching } = useInfiniteQuery<
    NotificationListView,
    Error
  >({
    queryKey: notificationsKeys.list(),
    initialPageParam: params,
    queryFn: async ({ pageParam }) => {
      const response = await MatchingApi.notifications.getNotifications(
        pageParam as NotificationsApiGetNotificationsRequest,
      );
      return response.data;
    },
    getNextPageParam: (lastPage) => {
      return lastPage.nextPageToken
        ? {
            limit: params.limit,
            nextPageToken: lastPage.nextPageToken,
          }
        : undefined;
    },
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: true,
  });

  const notifications = data?.pages.flatMap((page) => page.items) || [];

  return {
    notifications,
    fetchNextPage,
    hasNextPage,
    isLoading,
    isFetching,
  };
};
